var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMingcuteSettings1Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28331 2.70247L9.28338 2.70243C9.48528 2.58582 9.71258 2.52023 9.94557 2.51133C10.1747 2.50259 10.4024 2.54893 10.6098 2.64638L10.7269 2.70841L15.9617 5.73001L15.9617 5.73003C16.1647 5.84715 16.3358 6.01225 16.4601 6.21085C16.5825 6.40632 16.6559 6.62839 16.6741 6.85817L16.6783 6.98218V13.0277C16.6783 13.0278 16.6783 13.0278 16.6783 13.0279C16.6782 13.2621 16.6208 13.4927 16.5109 13.6996C16.4025 13.9038 16.2462 14.0788 16.0556 14.2095L15.9509 14.2758L10.7167 17.2975L10.7165 17.2975C10.5146 17.4141 10.2873 17.4797 10.0544 17.4886C9.82573 17.4973 9.59841 17.4512 9.39136 17.3542L9.27424 17.2914L4.0382 14.2708C4.03817 14.2707 4.03814 14.2707 4.03811 14.2707C3.8352 14.1536 3.6641 13.9885 3.53978 13.7899C3.4174 13.5945 3.34403 13.3724 3.32581 13.1426L3.32163 13.0186L3.32163 6.97238C3.32163 6.97234 3.32163 6.9723 3.32163 6.97227C3.32163 6.9722 3.32163 6.97213 3.32163 6.97206C3.3218 6.73787 3.37935 6.50729 3.48924 6.30048C3.59782 6.09617 3.75421 5.92121 3.94503 5.79052L4.04984 5.72415L9.28331 2.70247Z",
    stroke: "black",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.875,
    stroke: "black",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteSettings1Line);
export default __webpack_public_path__ + "static/media/mingcute_settings-1-line.06794354e761364479a4b4e40fc15d01.svg";
export { ForwardRef as ReactComponent };